import { ACTIVE_USERS_LIST_TAG, LIST_QUERY_CACHE_TTL_SECONDS, UserRoleLabels, UserRoleType } from '@/api';
import { api } from '@/api';

export interface ActiveUserData {
  createdDate: string;
  userEmail: string;
  userId: string;
  fullName: string;
  userName: string;
  userRole: string;
  status?: string;
}

type UsersListApiUser = {
  id: string;
  name?: string;
  greeting?: string;
  role?: string;
  email?: string;
  createdDate?: string;
  status?: string;
};

type UsersListApiResponse = {
  users: UsersListApiUser[];
  totalCount?: number;
};

export interface GetActiveUsersRequest {
  pageIndex: number;
  pageSize: number;
  name?: string;
}

const getActiveUsersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getActiveUsers: builder.query<{ numberOfResults: number; users: ActiveUserData[] }, GetActiveUsersRequest>({
      query: ({ pageIndex, pageSize, name }: GetActiveUsersRequest) => ({
        url: `users/list`,
        method: 'GET',
        params: { pageIndex: pageIndex, pageSize: pageSize, name: name },
      }),
      transformResponse: (response: UsersListApiResponse) => {
        const mappedUsers: ActiveUserData[] = response.users.map((u) => {
          const name = u.name ?? '';
          const createdDate = u.createdDate ?? '';
          const role = u.role ?? '';
          const email = u.email ?? '';
          const status = u.status ?? '';

          return {
            userId: u.id,
            userName: name,
            fullName: name,
            userEmail: email,
            userRole: UserRoleLabels[role as UserRoleType],
            createdDate,
            status,
          };
        });

        return {
          users: mappedUsers,
          numberOfResults: response.totalCount ?? 0,
        };
      },
      providesTags: (_result, _error, { pageIndex, pageSize }) => [
        { type: ACTIVE_USERS_LIST_TAG, id: `${pageIndex}-${pageSize}` },
      ],
      extraOptions: { maxRetries: 3 },
      keepUnusedDataFor: LIST_QUERY_CACHE_TTL_SECONDS,
    }),
  }),
});

export const { useLazyGetActiveUsersQuery } = getActiveUsersApi;
